import { Factory } from '../../../lib/api';
const createPolygon = (teamId, payload) => Factory.post('api/v2/polygons', {}, { team_id: teamId, ...payload });
export default createPolygon;
